module.exports = {"component":"page-header","status":"prod","display-name":"Page Headers","SLDS-component-path":"/components/page-headers","url-slug":"page-headers"}


//////////////////
// WEBPACK FOOTER
// ./components/page-header/docs.json
// module id = 310
// module chunks = 0